import { css } from "lit";

import "./fonts/fonts.css";
import "./props.css";

export { colors } from "@pentacode/core/src/colors";


// TODO: remove global config when refactoring shared style imports
export const config = css``;
